import { type DepartmentApiModel } from '@webapp/core/data-access/api-models/DepartmentApiModel'
import { type LocationApiModel } from '@webapp/core/data-access/api-models/LocationApiModel'
import { mapDepartment } from '@webapp/core/data-access/mappers/mapDepartment'
import { mapLocation } from '@webapp/core/data-access/mappers/mapLocation'
import { type PrimaryCategoryConstructor } from '@webapp/core/entities/internal/PrimaryCategory'
import { type SecondaryCategoryConstructor } from '@webapp/core/entities/internal/SecondaryCategory'
import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IRequestableCategoryRepository } from '../../../business-logic/interfaces/IRequestableCategoryRepository'

interface Dependency {
  httpClient: IHttpClient
}

export class RequestableCategoryRepository implements IRequestableCategoryRepository {
  constructor(private readonly deps: Dependency) {}

  async listRequestableLocations(): Promise<PrimaryCategoryConstructor[]> {
    try {
      const res = await this.deps.httpClient.get<
        ApiResponse<LocationApiModel[]>
      >(`/api/v3/locations/`, {
        params: {
          requestable: 'EXPENSE',
          page_size: 999,
        },
      })

      return res.data.data.map(mapLocation)
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }

  async listRequestableDepartments(
    branchId: number
  ): Promise<SecondaryCategoryConstructor[]> {
    try {
      const res = await this.deps.httpClient.get<
        ApiResponse<DepartmentApiModel[]>
      >(`/api/department/requestable/`, {
        params: {
          branch: branchId,
          type: 'expense',
          page_size: 999,
        },
      })

      return res.data.data.map(mapDepartment)
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
